import { createContext, useContext } from "react";

export type Passcode = string | null | undefined;

export interface PassCodeContextValue {
  passcode: Passcode;
  setPasscode: (passcode: Passcode) => void;
}

export const PasscodeContext = createContext<PassCodeContextValue>({
  passcode: "",
  setPasscode: () => undefined,
});

export function usePasscodeContext(): PassCodeContextValue {
  const context = useContext(PasscodeContext);
  if (!context) throw new Error("PasscodeContext must be initialized.");
  return context;
}
